import { render } from "./D_Puppies.vue?vue&type=template&id=415356e4&scoped=true"
import script from "./D_Puppies.vue?vue&type=script&lang=js"
export * from "./D_Puppies.vue?vue&type=script&lang=js"

import "./D_Puppies.vue?vue&type=style&index=0&id=415356e4&scoped=true&lang=css"

import exportComponent from "/Users/jessicabohland/Documents/Code/Website/gonsbachtal-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-415356e4"]])

export default __exports__